var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
/* eslint-disable @typescript-eslint/space-before-function-paren */
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
var ListBoxComponent = forwardRef(function ListBoxBase(props, ref) {
    var children = props.children, rest = __rest(props, ["children"]);
    var innerRef = useRef(null);
    useImperativeHandle(ref, function () { return innerRef.current; });
    return (React.createElement(React.Fragment, null,
        React.createElement("ul", __assign({}, rest, { ref: innerRef, role: "list-box" }), children)));
});
export default ListBoxComponent;
//# sourceMappingURL=ListBoxComponent.js.map